var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataAsc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.474442 0.500001C0.0506282 0.500001 -0.161279 0.9375 0.144809 1.20833L3.15859 3.875C3.34696 4.04167 3.65304 4.04167 3.84141 3.875L6.85519 1.20833C7.16128 0.937501 6.94937 0.500001 6.52556 0.500001L0.474442 0.500001Z",
    fill: "#B6C2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAsc);
export default __webpack_public_path__ + "static/media/data-asc.be5b02cdbf9d59bd8d06fb6c78a80541.svg";
export { ForwardRef as ReactComponent };